import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

interface ModEligibilityConfirmDialogProps {
  isOpen: boolean;
  action: 'enable' | 'disable';
  mods: Array<{ modCoverageId: number; tagName: string }>;
  onConfirm: () => void;
  onClose: () => void;
  isSubmitting: boolean;
}

export const ModEligibilityConfirmDialog: React.FC<ModEligibilityConfirmDialogProps> = ({
  isOpen,
  action,
  mods,
  onConfirm,
  onClose,
  isSubmitting,
}) => {
  if (!isOpen) return null;

  const title = action === 'enable' ? 'Enable PC & PR' : 'Disable PC & PR';
  const confirmLabel = action === 'enable' ? 'Enable PC & PR' : 'Disable PC & PR';
  const confirmClass =
    action === 'enable' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700';

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-lg font-bold">{title}</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full">
            <CloseIcon />
          </button>
        </div>

        <div className="px-6 py-4">
          <p className="text-sm text-gray-700 mb-3">
            You are about to {action} PC & PR for the following {mods.length} mod
            {mods.length === 1 ? '' : 's'}:
          </p>
          {mods.length < 10 ? (
            <div className="max-h-72 overflow-y-auto border rounded-md divide-y">
              {mods.map((mod) => (
                <div
                  key={mod.modCoverageId}
                  className="flex items-center justify-between px-3 py-2 text-sm"
                >
                  <span className="font-medium">{mod.tagName}</span>
                  <span className="text-gray-400 text-xs">#{mod.modCoverageId}</span>
                </div>
              ))}
            </div>
          ) : (
            <div
              className="max-h-72 overflow-y-auto border rounded-md px-3 py-2 text-sm"
              style={{ overflowWrap: 'normal', wordBreak: 'normal' }}
            >
              {mods.map((m) => m.tagName.replace(/-/g, '\u2011')).join(', ')}
            </div>
          )}
        </div>

        <div className="flex justify-end gap-2 px-6 py-4 border-t">
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 text-sm font-medium disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isSubmitting}
            className={`px-4 py-2 text-white rounded-md text-sm font-medium disabled:opacity-50 ${confirmClass}`}
          >
            {isSubmitting ? 'Working...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
